import { zfcfsv } from "./zfc_video";
import { Swiper, Navigation, Pagination, A11y } from "./swiper-config";
export class zfclightbox {
    static close(c, clone, lightbox) {
        $(document).off("keyup.zfclightbox", zfclightbox.watchKeys);
        var cloneActiveIndex = clone.activeIndex;
        var galleryDescCheck = !c.elem.hasClass("zfcgac-gallery-teaser-mobile") && (c.elem.find(".zfcgac-item-active").index() != cloneActiveIndex);
        if (galleryDescCheck || c.clonedSlider.activeIndex != cloneActiveIndex) {
            c.clonedSlider.slideTo(cloneActiveIndex);
        }
        clone.destroy();
        lightbox.remove();
    }
    static create(c) {
        var clone = c.elem.clone();
        clone.attr("id", clone.attr("id") + "_lightbox");
        if (c.useSwiper) {
            clone.find(".swiper-wrapper .swiper-slide").addClass("zfc-light-item");
        }
        else {
            clone.children().addClass("zfc-light-item");
        }
        return function (target) {
            var lightbox = $('<div class="zfc-lightbox"></div>');
            var overlay = $('<div class="zfc-lightbox-overlay"></div>');
            var container = target.hasClass("zfcgac-item-fullscreen")
                ? $('<div class="zfc-lightbox-container zfc-lightbox-container-fullscreen"></div>')
                : $('<div class="zfc-lightbox-container"></div>');
            var closeButton = $('<button type="button" class="zfcui-icon zfc-lightbox-overlay-close"></button>');
            var dotContainer = $('<div class="zfc-lightbox-dot-container"></div>');
            if (c.slick && c.useSwiper == true) {
                var lightboxSlideCount = clone.find(".swiper-wrapper .swiper-slide").length;
                lightbox.append(overlay).append(closeButton).append(container);
                container.append(clone);
                container.append(dotContainer);
                lightbox.appendTo("body");
                const swiper = new Swiper("#" + clone.attr("id"), {
                    modules: [Navigation, Pagination, A11y],
                    allowTouchMove: true,
                    spaceBetween: 24,
                    loop: false,
                    normalizeSlideIndex: true,
                    noSwipingSelector: '.playkit-control-button',
                    slidesPerView: 1,
                    preventClicks: false,
                    preventClicksPropagation: false,
                    navigation: {
                        enabled: lightboxSlideCount > 1,
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    pagination: {
                        enabled: true,
                        el: ".swiper-pagination",
                        type: "custom",
                        clickable: true,
                        renderCustom: function (swiper, current, total) {
                            var out = "";
                            for (var i = 1; i < total + 1; i++) {
                                if (i == current) {
                                    out =
                                        out +
                                            '<button class="swiper-pagination-bullet swiper-pagination-bullet-active" role="button" aria-label="Go to slide ' +
                                            i +
                                            1 +
                                            '"></button>';
                                }
                                else {
                                    out =
                                        out +
                                            '<button class="swiper-pagination-bullet" role="button" aria-label="Go to slide ' +
                                            i +
                                            1 +
                                            '"></button>';
                                }
                            }
                            return out;
                        },
                    },
                    a11y: {
                        enabled: true,
                        nextSlideMessage: "Next slide",
                        prevSlideMessage: "Previous slide",
                        paginationBulletMessage: "Jump to slide {{index}}",
                        slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                        slideRole: "group",
                        itemRoleDescriptionMessage: "slide",
                    },
                });
                swiper.update();
                if (target && target.data) {
                    if (target.closest(".zfcgac-item").data("swiper-slide-index") == undefined) {
                        swiper.slideTo(c.elem.find(".zfcgac-item-active").index());
                    }
                    else {
                        swiper.slideTo(c.clonedSlider.realIndex);
                    }
                }
                closeButton
                    .off("click.zfclightbox")
                    .on("click.zfclightbox", function () {
                    zfclightbox.close(c, swiper, lightbox);
                });
                overlay
                    .off("click.zfclightbox")
                    .on("click.zfclightbox", function () {
                    zfclightbox.close(c, swiper, lightbox);
                });
            }
            else if (c.slick && c.useSwiper == true) {
                clone.slick({
                    rows: 0,
                    swipeToSlide: true,
                    slidesToShow: 1,
                    infinite: true,
                    arrows: true,
                    dots: true,
                    swipe: true,
                    transformEnabled: false,
                    dotsClass: "not-default custom-dots",
                    appendDots: dotContainer,
                });
                if (target && target.data && target.data("slick-index") !== "") {
                    clone.slick("slickGoTo", target.data("slick-index"), true);
                }
                clone.on("beforeChange", function () {
                    clone.lastItem = clone[0].slick.currentSlide;
                });
                clone.on("afterChange", function () {
                    if (clone.lastItem !== clone[0].slick.currentSlide) {
                    }
                });
                lightbox.append(overlay).append(container).append(closeButton);
                container.append(clone);
                container.append(dotContainer);
                lightbox.appendTo("body");
            }
            var findVideo = c.useSwiper
                ? ".swiper-slide[data-video]"
                : ".slick-slide[data-video]:not(.slick-cloned)";
            $(".zfc-lightbox-container")
                .find(findVideo)
                .each(function () {
                var that = $(this);
                if (that.data("video").toString().length) {
                    var videoHtml = $(zfcfsv.videoPartHtml.replace("videoId", that.data("video")));
                    that.find(".zfc-media-container").empty();
                    that.find(".zfc-media-container").append(videoHtml);
                    if (!zfcfsv.initialized)
                        zfcfsv.init();
                    else
                        zfcfsv.initFullSizeVideo(that.find(".zfcfsv-full-size-video"));
                }
            });
            function watchKeys(e) {
                var prev = c.useSwiper ? "swiper-button-prev" : "slickPrev";
                var next = c.useSwiper ? "swiper-button-next" : "slickNext";
                switch (e.which) {
                    case 27:
                        zfclightbox.close(c, clone, lightbox);
                        break;
                    case 37:
                        clone.slick(prev);
                        break;
                    case 39:
                        clone.slick(next);
                        break;
                    default:
                        return;
                }
                e.preventDefault();
            }
            zfclightbox.watchKeys = watchKeys;
            $(document)
                .off("keyup.zfclightbox")
                .on("keyup.zfclightbox", zfclightbox.watchKeys);
        };
    }
}
zfclightbox.lightboxTouched = false;
